import styled from '@emotion/styled';
import { rem } from '@utils';

const Wrapper = styled.span<{ hasTooltip?: boolean }>(
  ({ theme, hasTooltip }) => `
  background: ${theme.palette.grey['100']};
  box-shadow: inset 0 0 0 1px ${theme.palette.grey['200']};
  border-radius: 20px;
  cursor: default;
  display: inline-flex;
  max-width: 100%;
  user-select: none;
  width: max-content;

  ${
    !hasTooltip
      ? `padding: ${rem(4)} ${rem(16)};`
      : `.chip-tooltip-anchor { 
        padding: ${rem(4)} ${rem(16)}; 
      }`
  }

  .icon {
    width: ${rem(14)};
    height: ${rem(14)};
    flex-shrink: 0;
  }

  * {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`
);

const Content = styled.span`
  display: flex;
  align-items: center;
  gap: ${rem(8)};
  text-transform: capitalize;
`;

export default {
  Wrapper,
  Content
};
